<template>
    <LoaderComponent v-model:data="AppLoaderData" />
    <div v-if="environment != 'PROD'">
		<div class="version-tag version-tag--beta">{{ `${environment} verzija` }}</div>
	</div>

    <ExportFactory/>
	<MessageBox/>
	<DocumentViewer/>
	<router-view />
</template>

<script setup lang="ts">
    import { MessageBox } from "fw4-library";
    import { DocumentViewer } from "fw4-library";
    import { LoaderComponent } from "nlb-buy-go-library";
    import { useLoaderData } from "@/app/store/app/component/loader-component";
    import { ExportFactory } from "fw4-library";

    const { AppLoaderData } = useLoaderData();
	const environment = import.meta.env.MODE;
</script>
